import { setLigne } from '../store/line-store.js'
import { lineSelected } from '../utils/dom-utils.js'
import { lignes } from '../lines.js'

export class LigneButtonElement extends HTMLElement {
	constructor() {
		super()

		const shadow = this.attachShadow({ mode: 'open' })

		this.button = document.createElement('button')
		this.button.textContent = this.getAttribute('ligne') || 'Ligne ?'

		const style = document.createElement('style')
		style.textContent = `
      button {
        background: ${this.getAttribute('background-color') || '#1e88e5'} ;
        color: ${this.getAttribute('color') || 'white'};
        border: none;
        padding: 8px 16px;
        border-radius: 16px;
        cursor: pointer;
		margin: 6px;
      }
      button:hover {
        background: #1565c0;
      }
    `

		this.button.addEventListener('click', () => {
			const ligne = this.button.textContent
			setLigne(ligne)

			lineSelected()
		})

		shadow.appendChild(style)
		shadow.appendChild(this.button)
	}

	setLine(name) {
		this.button.textContent = name
		this.button.style.background = lignes.get(name) || '#1e88e5'
	}
}

customElements.define('ligne-button', LigneButtonElement)
